var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('van-nav-bar',{attrs:{"left-arrow":"","fixed":"","z-index":10,"title":_vm.item.title},on:{"click-left":function($event){return _vm.goableBack()}}}),_vm._l((_vm.numPages),function(item){return _c('pdf',{key:item,attrs:{"src":_vm.src,"page":item}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }